import { FieldTypes, ISettingsMap } from '@/models/settings.model';
import { SettingsFormFields, TSettingsFormValues } from './types';
import { SupportedLocales } from '@/models/localization.model';

export const getInitialValues = (data: Partial<ISettingsMap>): Partial<TSettingsFormValues> => ({
  [SettingsFormFields.CONTACT_EMAIL]: data?.[FieldTypes.CONTACT_EMAIL]?.value,
  [SettingsFormFields.CONTACT_PHONE]: data?.[FieldTypes.CONTACT_PHONE]?.value,
  [SettingsFormFields.GOOGLE_ANALYTICS]: data?.[FieldTypes.GOOGLE_ANALYTICS]?.value,
  [SettingsFormFields.ADMIN_EMAILS]: data?.[FieldTypes.ADMIN_EMAILS]?.value,
  [SettingsFormFields.ORDER_EMAILS]: data?.[FieldTypes.ORDER_EMAILS]?.value,
  [SettingsFormFields.PRICE_CHANGE_ADMIN_EMAILS]: data?.[FieldTypes.PRICE_CHANGE_ADMIN_EMAILS]?.value,
  [SettingsFormFields.FACEBOOK]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.facebook,
  [SettingsFormFields.INSTAGRAM]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.instagram,
  [SettingsFormFields.TWITTER]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.twitter,
  [SettingsFormFields.THREADS]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.threads,
  [SettingsFormFields.VIBER]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.viber,
  [SettingsFormFields.TELEGRAM]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.telegram,
  [SettingsFormFields.TIK_TOK]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.tiktok,
  [SettingsFormFields.YOUTUBE]: data?.[FieldTypes.SOCIAL_LINKS]?.value?.youtube,
  [SettingsFormFields.FOP_ID]: data?.[FieldTypes.FOP_MERCHANT]?.value,
  [SettingsFormFields.FOP_DESCRIPTION]: data?.[FieldTypes.FOP_MERCHANT_DESCRIPTION]?.value,
  [SettingsFormFields.TOV_ID]: data?.[FieldTypes.TOV_MERCHANT]?.value,
  [SettingsFormFields.TOV_DESCRIPTION]: data?.[FieldTypes.TOV_MERCHANT_DESCRIPTION]?.value,
  [SettingsFormFields.MIN_ORDER_TOTAL]: Number(data?.[FieldTypes.MIN_ORDER_TOTAL]?.value ?? 0),
  [SettingsFormFields.FOP_CASH_REGISTER_ID]: data?.[FieldTypes.FOP_CASH_REGISTER_ID]?.value,
  [SettingsFormFields.TOV_CASH_REGISTER_ID]: data?.[FieldTypes.TOV_CASH_REGISTER_ID]?.value,
  [SettingsFormFields.FOP_CASHIER_NAME]: data?.[FieldTypes.FOP_CASHIER_NAME]?.value,
  [SettingsFormFields.TOV_CASHIER_NAME]: data?.[FieldTypes.TOV_CASHIER_NAME]?.value,
  [SettingsFormFields.FOP_FISCAL_DEPARTMENT]: data?.[FieldTypes.FOP_FISCAL_DEPARTMENT]?.value,
  [SettingsFormFields.TOV_FISCAL_DEPARTMENT]: data?.[FieldTypes.TOV_FISCAL_DEPARTMENT]?.value,
  [SettingsFormFields.ADDRESS]: {
    latitude: parseFloat(data?.[FieldTypes.LATITUDE]?.value ?? '0'),
    longitude: parseFloat(data?.[FieldTypes.LONGITUDE]?.value ?? '0'),
    place_id: data?.[FieldTypes.EXTERNAL_MAP_ID]?.value ?? '',
    locale: {
      [SupportedLocales.RU]: {
        name: data?.[FieldTypes.ADDRESS]?.locale?.[SupportedLocales.RU]?.name ?? '',
      },
      [SupportedLocales.UK]: {
        name: data?.[FieldTypes.ADDRESS]?.locale?.[SupportedLocales.UK]?.name ?? '',
      },
    },
  },
  [SettingsFormFields.LOCALE]: {
    [SupportedLocales.RU]: {
      [SettingsFormFields.WORKING_HOURS]: data?.[FieldTypes.WORKING_HOURS]?.locale?.[SupportedLocales.RU]?.name ?? '',
    },
    [SupportedLocales.UK]: {
      [SettingsFormFields.WORKING_HOURS]: data?.[FieldTypes.WORKING_HOURS]?.locale?.[SupportedLocales.UK]?.name ?? '',
    },
  },
});
